export const ENV = {
  CONTACT_URL: "https://www.fibretrace.io/contact",
  FIBRETRACE_V2_SHOPIFY_URL: "https://shopify-webapp-dev.fibretrace.io",
  API_URL: "https://admin-webapp-dev.fibretrace.io/api/v1",
  API_URL_ALT: "https://admin-webapp-dev.fibretrace.io/api/",
  API_VERSION: "v1",
  API_VERSION_ALT: "v2",
  GG_KEY: "AIzaSyBXySZJinSRuZmftdMItkfg7taf4_o9DTI",
  AWS_S3_FILE_UPLOAD: "https://fibretrace.s3.amazonaws.com/fibretrace/FIP/self/misc/template_file_upload",
  URL_WEBAPP: "https://webapp-dev.fibretrace.io"
}
